module.exports = __webpack_public_path__ + "45e9abceb560dc51ee4cfa0a061553d0.png";